import Modal from "../../../common/modal/Modal";
import './DeleteOrderModal.scss';

const DeleteOrderModal = ({onDelete, onClose}) => {
    return (
        <Modal isOpen>
            <div className="delete-order-modal">
                <div className="close-button" onClick={onClose}/>
                <p>Are you sure that you want to delete this order?</p>
                <div className="delete-order-modal__buttons">
                    <button className="default-button" onClick={onDelete}>Yes</button>
                    <button className="default-button default-button--grey" onClick={onClose}>No</button>
                </div>
            </div>
        </Modal>
    );
}

export default DeleteOrderModal;
